module.exports = __webpack_public_path__ + "img/liucheng0.19addfe1.png";